import { render, staticRenderFns } from "./TestHistory.vue?vue&type=template&id=2a6b5238&scoped=true&"
import script from "./TestHistory.vue?vue&type=script&lang=js&"
export * from "./TestHistory.vue?vue&type=script&lang=js&"
import style0 from "./TestHistory.vue?vue&type=style&index=0&id=2a6b5238&scoped=true&lang=css&"
import style1 from "./TestHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6b5238",
  null
  
)

export default component.exports